import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';

export const directionsServiceApi = createApi({
  reducerPath: 'directionsServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    SearchDirections: builder.query<any, string>({
      query: (txt) => ({
        url: `/search/nora/txt?txt=${txt}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazySearchDirectionsQuery } = directionsServiceApi;
